import { Icon, Menu } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useCallback, useState } from "react";
import ArchivedEmployeeMenuItems from "./MenuItems/ArchivedMenuItems";

export default function ArchivedActionsCell({ value, row }: { value: string; row: any }) {
  const [anchorElement, setAnchorElement] = useState<Element | null>(null);
  const closeMenu = useCallback(() => {
    setAnchorElement(null);
  }, []);

  return (
    <>
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(anchorElement)}
        onClose={closeMenu}
        keepMounted
      >
        <ArchivedEmployeeMenuItems id={row.values.id} closeMenu={closeMenu} />
      </Menu>
      <MDTypography
        color="secondary"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
          setAnchorElement(e.currentTarget)
        }
      >
        <Icon sx={{ cursor: "pointer", fontWeight: "bold" }}>more_vert</Icon>
      </MDTypography>
    </>
  );
}
